import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

/** Lucide `chevron-right`, from the vendored font the sidebar icons use. */
const CHEVRON_RIGHT = String.fromCodePoint(0xe06f);

interface PanelLinkProps {
  to: string;
  children: ReactNode;
}

/**
 * The quiet "go further" link in a Home panel's head or line: muted text and a
 * chevron drawn from the icon font, never a typed arrow. Decorative glyph, so
 * the label alone is what a screen reader hears.
 */
export function PanelLink({ to, children }: PanelLinkProps) {
  return (
    <Link className="panel-link" to={to}>
      <span>{children}</span>
      <span className="panel-link__icon" aria-hidden="true">
        {CHEVRON_RIGHT}
      </span>
    </Link>
  );
}
